export default __webpack_public_path__ + "static/media/leave.55904eda.mp3";